import { getMemberAddress } from '@musinsa/apis-curator';
import { withServiceErrorCapture } from '@musinsa/services-common-service-zod4';

import type { SeedingDeliveryAddressItem } from './get-seeding-delivery-addresses.dto';

/**
 * 무신사 배송지 단건 조회 → 시딩 공용 배송지 DTO(`SeedingDeliveryAddressItem`)로 매핑.
 *
 * order-group 팝업에서 선택한 `selectedAddressId` 로 order-service 를 조회해, 화면 표시·
 * 신청/수락 payload(`deliveryAddressId`) 에 그대로 쓰는 공용 형태로 변환한다.
 *
 * 매핑: title→addressName, isDefault→isPrimary, mobile(우선)|phone→phone,
 *       deliveryMessage→memo.
 */
export const getMemberAddressService = withServiceErrorCapture(
  async (addressId: number): Promise<SeedingDeliveryAddressItem> => {
    const response = await getMemberAddress({ addressId });

    if (!response.result) {
      throw new Error(response.message ?? '배송지 조회에 실패했습니다.');
    }

    const address = response.data;
    return {
      id: address.id,
      addressName: address.title ?? null,
      isPrimary: address.isDefault,
      name: address.name,
      phone: address.mobile || address.phone || '',
      zipcode: address.zipcode,
      address1: address.address1,
      address2: address.address2 ?? null,
      memo: address.deliveryMessage ?? null,
    };
  },
);
